export default "__VITE_ASSET__CKo$2Xxl__";